import TOUCH_TARGET_PX from './touchTarget';

export const PAGE_NOTICE_TITLE_ID = 'page-notice-title';
export const MESSAGE_MIN_WIDTH_PX = 320;
export const LINE_HEIGHT_PX = 20;
export const ACTION_HEIGHT_PX = 32;
export const INFO_ICON_SIZE_PX = 20;
export const SKIP_ICON_SIZE_PX = 20;
export const FIRST_LINE_OFFSET_PX = (ACTION_HEIGHT_PX - LINE_HEIGHT_PX) / 2;
export const SKIP_PADDING_PX = (ACTION_HEIGHT_PX - SKIP_ICON_SIZE_PX) / 2;
export const COMPACT_SKIP_OFFSET_PX = (TOUCH_TARGET_PX - SKIP_ICON_SIZE_PX) / 2;
export const COMPACT_LAYOUT = '"icon message skip" "actions actions actions"';
export const NOTICE_PADDING_SPACING = 1;
export const COMPACT_NOTICE_PADDING_SPACING = 1.5;
export const NOTICE_PADDING_LEFT_SPACING = 2;
export const NOTICE_GAP_SPACING = 1.5;
export const BODY_COLUMN_GAP_SPACING = 3;
export const BODY_ROW_GAP_SPACING = 0.5;
export const ACTIONS_GAP_SPACING = 1;
